import request from '@/utils/request'
const apiPath = '/live/liveReward'
import { downloadBlob } from '@/utils/download'
const liveRewardApi = {
  /**
   * 新增【直播打赏配置】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【直播打赏配置】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【直播打赏配置】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【直播打赏配置】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【直播打赏配置】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '打赏配置列表.xlsx'))
  },
}
export default liveRewardApi
